"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const constants = require("@/common/constants");
const GameOverview_vue_1 = require("@/client/components/admin/GameOverview.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'games-overview',
    data() {
        return {
            entries: [],
        };
    },
    mounted() {
        this.getGames();
    },
    components: {
        GameOverview: GameOverview_vue_1.default,
    },
    methods: {
        async getGames() {
            try {
                const response = await fetch('api/games?serverId=' + this.serverId);
                if (!response.ok) {
                    alert('Unexpected response fetching games from API');
                    return;
                }
                const result = await response.json();
                if (result instanceof Array) {
                    this.entries = result.map((response) => ({
                        id: response.gameId,
                        game: undefined,
                        status: 'loading',
                    }));
                    this.entries.forEach((_, idx) => this.getGame(idx));
                }
                else {
                    alert('Unexpected response fetching games from API');
                }
            }
            catch (error) {
                alert('Error getting games data');
            }
        },
        async getGame(idx) {
            if (idx >= this.entries.length) {
                return;
            }
            const entry = this.entries[idx];
            const gameId = entry.id;
            try {
                const response = await fetch('api/game?id=' + gameId);
                if (response.ok) {
                    const game = await response.json();
                    entry.status = 'done';
                    entry.game = game;
                }
                else {
                    entry.status = 'error';
                }
            }
            catch (error) {
                entry.status = 'error';
            }
        },
    },
    computed: {
        constants() {
            return constants;
        },
        serverId() {
            return (new URL(location.href)).searchParams.get('serverId') || '';
        },
    },
});
